<script setup lang="ts">
import { ulid } from "ulid";
import { ref, onMounted, onUnmounted } from "vue";

const id = ulid();

const props = withDefaults(
  defineProps<{
    class?: string | Object;
    href?: string;
    to?: string;
  }>(),
  {}
);

const emits = defineEmits<{
  (onClick: "onClick"): void;
  (onClose: "onClose"): void;
}>();

const onClicked = () => {
  onClick();
  onClose();
};

function onClick() {
  emits("onClick");
}

function onClose() {
  emits("onClose");
}

onMounted(async () => {});
</script>

<template>
  <template v-if="to">
    <RouterLink
      v-if="to"
      :to="to"
      class="bg-menu-base hover:bg-main-light-hover flex w-full cursor-pointer items-center justify-center p-2.5"
      :class="props.class"
    >
      <div>
        <slot />
      </div>
    </RouterLink>
  </template>
  <template v-else>
    <a
      v-if="href"
      :href="href"
      class="bg-menu-base hover:bg-main-light-hover flex w-full cursor-pointer items-center justify-center p-2.5"
      :class="props.class"
    >
      <div>
        <slot />
      </div>
    </a>
  </template>
  <template v-else>
    <div
      @click="onClicked"
      :class="props.class"
      class="bg-menu-base hover:bg-main-light-hover flex w-full cursor-pointer items-center justify-center p-2.5"
    >
      <slot />
    </div>
  </template>
</template>
